// eslint-disable-next-line import/prefer-default-export
export function htmlNormalizeImageRatio(html) {
  return html.replace(/<img([^>]*?)>/g, (match, attributes) => {
    const widthMatch = attributes.match(/width\s*=\s*["'](\d+)["']/);
    const heightMatch = attributes.match(/height\s*=\s*["'](\d+)["']/);

    if (widthMatch && heightMatch) {
      const width = parseInt(widthMatch[1], 10);
      const height = parseInt(heightMatch[1], 10);

      if (!Number.isNaN(width) && !Number.isNaN(height)) {
        const aspectRatio = width / height;
        const styleAttributeMatch = attributes.match(/style\s*=\s*["']([^"']*)["']/);

        if (styleAttributeMatch) {
          const existingStyles = styleAttributeMatch[1];
          const newStyles = `${existingStyles}; aspect-ratio: ${aspectRatio};`;
          return `<img${attributes.replace(existingStyles, newStyles)}>`;
        }

        return `<img${attributes} style="aspect-ratio: ${aspectRatio};">`;
      }
    }

    return match;
  });
}
